<template>
  <div id="nav">
    <ul class="step-indicator">
      <li v-for="(step, idx) in orderSteps" :key="idx" :class="[ step.visited ? 'visited' : (step.active ? 'active' : '') ]">

        <router-link v-if="step.visited" :to="{ name: step.url }">
          <span class="step-bubble">
            <i :class="step.icon"></i>
          </span>
        </router-link>

        <span v-if="!step.visited" class="step-bubble"><i :class="step.icon"></i></span>

        <div>{{ step.label }}</div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'StepIndicator',
  computed: {
    orderSteps() {
      const steps = this.$store.getters.getOrderSteps;
      this.scrollTop();
      return this.getCurrentOrderSteps(steps);
    },
  },
  methods: {
    getCurrentOrderSteps(steps){
      let stepsArray = [];
      let hasCurrentStep = false;
      let currentStepName = this.$store.getters.getCurrentStep;

      for (let step in steps) {
        let stepObject = steps[step];
        stepObject.visited = true;
        stepObject.active = false;

        if(!hasCurrentStep){
          if(currentStepName === stepObject.url){
            stepObject.visited = false;
            stepObject.active = true;
            hasCurrentStep = true;
          }
        }else{
          stepObject.visited = false;
        }

        stepsArray[step] = stepObject;
      }

      return stepsArray;
    },
    scrollTop(){
        window.scrollTo(0,0);
    }
  }
}
</script>